/* eslint-disable react/prop-types */
/* eslint-disable max-lines */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/boolean-prop-naming */
/* eslint-disable react/no-unused-state */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-ProductReviewListtheme
 */

import PropTypes from 'prop-types';
import { lazy, Suspense } from 'react';

import Breadcrumbs from 'Component/Breadcrumbs';
import ContentWrapper from 'Component/ContentWrapper';
import { ProductCarousel } from 'Component/Html/Html.component';
import ProductActions from 'Component/ProductActions';
import ProductInformation from 'Component/ProductInformation';
import {
    SCROLL_TO_TOP_BUTTON_SHOW_PX
} from 'Component/ScrollToTopButton/ScrollToTopButton.config';
import { Html } from 'Route/CategoryPage/CategoryPage.component';
import NoMatchHandler from 'Route/NoMatchHandler';
import { RECOMMENDER_PDP_ID } from 'Route/ProductPage/ProductPage.config';
import {
    ProductPage as SourceProductPage
} from 'SourceRoute/ProductPage/ProductPage.component';
import { handleIosStickyHeader } from 'Util/PromoBanner/PromoBanner';

import './ProductPage.style';
import './ProductPage.style.override';

// eslint-disable-next-line max-len
export const ScrollToTopButton = lazy(() => import(/* webpackMode: "lazy", webpackChunkName: "footer" */ 'Component/ScrollToTopButton/ScrollToTopButton.component'));

/** @namespace Scandipwa/Route/ProductPage/Component */
export class ProductPageComponent extends SourceProductPage {
    static propTypes = {
        ...super.propTypes,
        productOptionsData: PropTypes.object.isRequired,
        product: PropTypes.object.isRequired,
        content_blocks: PropTypes.array,
        // eslint-disable-next-line react/no-unused-prop-types
        customer: PropTypes.object,
        // eslint-disable-next-line react/no-unused-prop-types
        locale: PropTypes.string.isRequired,
        basePath: PropTypes.string.isRequired
    };

    state = {
        isScrollToTopButtonRender: false
    };

    static defaultProps = {
        customer: {},
        content_blocks: []
    };

    componentDidMount() {
        window.addEventListener('scroll', this.getScrollPosition);
        handleIosStickyHeader();
        window.backButtonFromPDP = true;
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.getScrollPosition);
    }

    getScrollPosition = () => {
        const scrollPositionY = window.scrollY;

        this.setState({
            isScrollToTopButtonRender: scrollPositionY >= SCROLL_TO_TOP_BUTTON_SHOW_PX
        });
    };

    getHighestVariantPrice() {
        const { product: { variants } } = this.props;

        if (!variants) {
            return null;
        }

        return Math.max(...variants.map((variant) => {
            const {
                price_range: {
                    minimum_price: {
                        final_price: {
                            value
                        }
                    }
                }
            } = variant;

            return value.toFixed(2);
        }));
    }

    renderProductPageContent() {
        const {
            getLink,
            dataSource,
            areDetailsLoaded,
            activeProduct,
            setActiveProduct,
            updateUrl,
            useEmptyGallerySwitcher,
            parameters,
            isVariant
        } = this.props;

        return (
            <ProductActions
              getLink={ getLink }
              product={ dataSource }
              parameters={ parameters }
              areDetailsLoaded={ areDetailsLoaded }
              setActiveProduct={ setActiveProduct }
              updateUrl={ updateUrl }
              isWithEmptySwitcher={ useEmptyGallerySwitcher }
              showLoader={ isVariant }
              productForGallery={ activeProduct }
              variantsHighPrice={ this.getHighestVariantPrice() }
            />
        );
    }

    renderAdditionalSections() {
        const {
            dataSource,
            parameters,
            areDetailsLoaded
        } = this.props;

        return (
            <ProductInformation
              product={ { ...dataSource, parameters } }
              areDetailsLoaded={ areDetailsLoaded }
            />
        );
    }

    renderOrganizationSchema() {
        const { basePath } = this.props;
        const logoUrl = window.publicPath === undefined ? '/assets/images/global/puma-og-logo.png'
            : `${ window.location.origin }${ window.publicPath }assets/images/global/puma-og-logo.png`;

        return (
            <div
              elem="ProductPage"
              block="OrganizationSchema"
              itemScope
              itemType="http://schema.org/Organization"
            >
                <meta itemProp="url" content={ basePath } />
                <meta itemProp="logo" content={ logoUrl } />
            </div>
        );
    }

    renderContentBlockPlaceholder() {
        return <div block="ProductPage" elem="ContentBlockPlaceholder" />;
    }

    renderContentBlocks() {
        const { content_blocks, product } = this.props;

        if (!content_blocks || !content_blocks.length) {
            return null;
        }

        if (!product || !product.id) {
            this.renderContentBlockPlaceholder();
        }

        return content_blocks.map((block) => (
            <Suspense fallback={ this.renderContentBlockPlaceholder() }>
                <Html key={ block.id } content={ block } />
            </Suspense>
        ));
    }

    renderCarousel() {
        const { history, productIds } = this.props;

        if (productIds.length === 0) {
            return null;
        }

        return (
            <ProductCarousel
              productSkuArray={ productIds }
              productButtonStyle={ null }
              title={ __('You may also like') }
              button=""
              carouselId="product_carousel_related"
              history={ history }
              isRecommender
            />
        );
    }

    render() {
        const { isScrollToTopButtonRender } = this.state;

        return (
            <NoMatchHandler>
                <Breadcrumbs />
                { isScrollToTopButtonRender
                && <Suspense fallback={ null }><ScrollToTopButton isProductPage /></Suspense> }
                <main
                  block="ProductPage"
                  aria-label="Product page"
                  itemScope
                  itemType="http://schema.org/Product"
                >
                    { this.renderOrganizationSchema() }
                    <meta itemProp="brand" content="Puma" />
                    <ContentWrapper
                      mix={ { block: 'ProductPage', elem: 'Section' } }
                      wrapperMix={ { block: 'ProductPage', elem: 'Wrapper' } }
                      label={ __('Main product details') }
                    >
                        { this.renderProductPageContent() }
                    </ContentWrapper>
                    { this.renderAdditionalSections() }
                    { this.renderContentBlocks() }
                    <div
                      id={ RECOMMENDER_PDP_ID }
                    >
                        { this.renderCarousel() }
                    </div>
                </main>
            </NoMatchHandler>
        );
    }
}

export default ProductPageComponent;
